import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelperService } from '@auth0/angular-jwt';
import decode from 'jwt-decode';

const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  getRoles() {
    throw new Error('Method not implemented.');
  }

  constructor(private cookieService: CookieService) { }


  private tokenKey: string = 'user_token';
  public isAuthenticated(): boolean {
    const token = this.getToken();
    return !jwtHelper.isTokenExpired(token);
  }
  public getTokenExpirationDate(): Date {
    const token = this.getToken();
    var a: Date = jwtHelper.getTokenExpirationDate(token);
    return a;
  }
  public getToken(): string {
    const token = localStorage.getItem(this.tokenKey);
    return token;
  }
  public saveToken(token: string) {
    localStorage.setItem(this.tokenKey, token);
  }
  public logout() {
    localStorage.removeItem(this.tokenKey);
  }
  public getRolesFromToken() {
    let roles;
    try {
      const t = decode(this.getToken());
      roles = t['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    }
    catch (e) { }
    return roles;
  }

}
